import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { Col, Form, InputNumber, Row, Radio, Button } from 'antd'

const StyledSettingsForm = styled.div({
  width: 205
})

const SettingsForm = ({ form, formKeys, data, onSubmit, loading }) => {
  const { getFieldDecorator } = form

  useEffect(() => {
    if (data[formKeys.MAX_PAGES]) {
      form.setFieldsValue({
        [formKeys.MAX_PAGES]: data[formKeys.MAX_PAGES]
      })
    }
    if (data[formKeys.MAX_STEPS]) {
      form.setFieldsValue({
        [formKeys.MAX_STEPS]: data[formKeys.MAX_STEPS]
      })
    }
    if (data[formKeys.PRIORITY]) {
      form.setFieldsValue({
        [formKeys.PRIORITY]: data[formKeys.PRIORITY]
      })
    }
  }, [data])
  return (
    <StyledSettingsForm>
      <Form layout="vertical" hideRequiredMark>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="MAX PAGES PER SCAN">
              {getFieldDecorator(formKeys.MAX_PAGES, {
                rules: [{ required: true, message: 'Please enter max pages' }]
              })(<InputNumber min={1} max={2000} step={100} placeholder="MAX PAGES" style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="MAX STEPS PER FLOW">
              {getFieldDecorator(formKeys.MAX_STEPS, {
                rules: [{ required: true, message: 'Please enter max steps' }]
              })(<InputNumber min={1} max={100} step={10} placeholder="MAX STEPS" style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="SCAN PRIORITY">
              {getFieldDecorator(formKeys.PRIORITY)(
                <Radio.Group buttonStyle="solid">
                  <Radio.Button value="Low">LOW</Radio.Button>
                  <Radio.Button value="Medium">MEDIUM</Radio.Button>
                  <Radio.Button value="High">HIGH</Radio.Button>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Button type="primary" style={{ width: '100%' }} onClick={onSubmit} loading={loading} disabled={loading}>
          SAVE CHANGES
        </Button>
      </Form>
    </StyledSettingsForm>
  )
}

export default SettingsForm
